import { forwardRef } from 'react';
import { AllieIcon, AllieIconProps, AllieCustomIcon } from '../../components/Icon';
import {
  ellipsisVertical,
  ellipsisHorizontal,
  eyeOutline,
  chevronForwardOutline,
  chevronUpOutline,
  chevronDownOutline,
  addCircleOutline,
  bookOutline,
  arrowBackCircleOutline,
  arrowBackOutline,
  arrowForwardOutline,
  closeCircle,
  closeCircleOutline,
  createOutline,
  flagOutline,
  closeOutline,
  logOutOutline,
  logInOutline,
  peopleOutline,
  checkmarkOutline,
  trashOutline,
  documentOutline,
  cloudUploadOutline,
  addCircle,
  add,
  alertCircleOutline,
  alertOutline,
  warningOutline,
  informationCircleOutline,
  checkmarkCircleOutline,
  trash,
  cubeOutline,
  timeOutline,
  timerOutline,
  layersOutline,
  playCircleOutline,
  chatboxOutline,
  chatbubbleOutline,
  chevronBackOutline,
  repeatOutline,
  calendarOutline,
  thumbsDownOutline,
  thumbsUpOutline,
  flaskOutline,
  stopCircleOutline,
  pauseCircleOutline,
  playOutline,
  caretUpOutline,
  caretDownOutline,
  listOutline,
  statsChartOutline,
  filterOutline,
  saveOutline,
  gridOutline,
  searchOutline,
  hardwareChipOutline,
  pulseOutline,
  refresh,
  pricetagOutline,
  apps,
  notificationsOffOutline,
  swapHorizontalOutline,
  hourglassOutline,
  banOutline,
  funnelOutline,
  sendOutline,
  removeCircleOutline,
  arrowUpCircle,
  speedometerOutline,
  trendingDownOutline,
  trendingUpOutline,
  pauseOutline,
  chatbubblesOutline,
  homeOutline,
  cogOutline,
  copyOutline,
  scanOutline,
  micOutline,
  linkOutline,
  helpCircleOutline,
  removeOutline,
  constructOutline,
} from 'ionicons/icons';
import {
  CalendarCheckIcon,
  ChartIcon,
  DownloadIcon,
  FilterIcon,
  LayersIcon,
  SortIcon,
  TimeForwardIcon,
  PulseIcon,
  MetricWarningIcon,
  TachometerIcon,
  RepeatIcon,
  SpeedometerIcon,
  EyeOpenIcon,
  EyeCloseIcon,
  CheckCircleIcon,
  ClockIcon,
  FileAddIcon,
  FlaskIcon,
  SadFaceIcon,
  NeutralFaceIcon,
  HappyFaceIcon,
  BellIcon,
  CheckSquareIcon,
  RadioOffIcon,
  ListIcon,
  WarningDiamondIcon,
  PastTimeIcon,
  BarChartIcon,
  FlipBackwardIcon,
  CalendarIcon,
  WarningIcon,
  DotIcon,
  TimeQuarterPastIcon,
  LayersTwoIcon,
  PlayCircleIcon,
  StopCircleIcon,
  PlayIcon,
  ArrowDownIcon,
  ArrowUpIcon,
  LineChartUpIcon,
  LikeIcon,
  DislikeIcon,
  FactoryGptIcon,
  SendIcon,
  StarsIcon,
  NotFoundIcon,
  RefreshIcon,
  RefreshDoubleIcon,
  DisconnectedIcon,
  ChevronsUpIcon,
  layoutRight,
  LightBulb,
  PlainCalendar,
  CloudMoon,
  Link,
  Package,
  Flag,
  MessageQuestionCircleIcon,
  LinkBrokenIcon,
  WarningCirclesIcon,
  PredictionIcon,
  UnplannedStopWarningIcon,
  PredictionDeactivatedIcon,
  PredictionIconLight,
  AlertCircle,
  ConcentricCirclesIcon,
  UploadIcon,
  RotationClockIcon,
  RotationControlIcon,
  File,
  SettingIcon,
  ZoomInIcon,
  SettingsAdvancedIcon,
  CoinsStackedIcon,
  Tool,
  SlashIcon,
  CoinsHands,
  TrendUp,
  FileSearchIcon,
  ScalesIcon,
  BarChartOutlineIcon,
  CurrencyDollarCircleIcon,
  ZapIcon,
  BellOutlineIcon,
  GearSettingIcon,
  ChartAnalyticsIcon,
  UserPersonIcon,
  SlashOctagonIcon,
  ChartBreakoutSquareIcon,
  FileLockIcon,
  FactoryGptAvatarIcon,
  PresentationChartIcon,
  FileSearchV2Icon,
  EditIcon,
  AllieAnimated,
  Star06Icon,
  Target,
  CoinsIcon,
  SettingError,
  LayoutAlt,
  HomeIcon,
  ChevronUpDouble,
  UnpluggedIcon,
  MonitorIcon,
  MoreVertIcon,
  MoreHorizCircleIcon,
  ProhibitionIcon,
  AllieLogo,
  EditPencil,
  EfficiencyMenuMobileApp,
  FactoryGptMenuMobileApp,
  AlertMenuMobileApp,
  AlertMenuSelectedMobileApp,
  EfficiencyMenuSelectedMobileApp,
  FactoryGptMenuSelectedMobileApp,
  PlainCheck,
  BanHexa,
  MenuBellMobileApp,
  MenuBellSelectedMobileApp,
  UserIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  WifiOffGenericIcon,
  WifiOffPageIcon,
  SparklesOutlineIcon,
  HammerOutlineIcon,
  CheckmarkDoneOutlineIcon,
  CloudOfflineIcon,
  CopyIcon,
  ImageCopyIcon,
  ThumbsUpIcon,
  ThumbsDownIcon,
  MenuSparksOutlineIcon,
  MenuSparksSolidIcon,
  MenuBellNotificationOutlineIcon,
  MenuBellNotificationSolidIcon,
  MenuDashboardSpeedOutlineIcon,
  MenuDashboardSpeedSolidIcon,
  MenuReportsOutlineIcon,
  MenuReportsSolidIcon,
  MenuMoneySquareOutlineIcon,
  MenuMoneySquareSolidIcon,
  MenuSettingsOutlineIcon,
  MenuSettingsSolidIcon,
  SidebarCollapseIcon,
  SidebarExpandIcon,
  HamburgerMenuIcon,
  AllieMenuLogo,
  CheckSquareSolidIcon,
  SquareOutlineIcon,
  LinkSlashIcon,
  CloudXmarkIcon,
} from './svg';
import { PinUnmarked } from './svg/pin-unmarked';
import { PinMarked } from './svg/pin-marked';
import { GridCompact } from './svg/grid-compact';
import { PredictionDeactivatedRoundedIcon } from './svg/prediction-deactivated-rounded';
import { SwitchVerticalIcon } from './svg/switch-vertical';
import { JournalPageIcon } from './svg/journal-page';
import { ClockStrokeIcon } from './svg/clock-stroke';
import { GraphUpIcon } from './svg/graph-up';
import { GearSettingStrokeIcon } from './svg/gear-setting-stroke';

export interface AllieMenuLogoIconProps extends AllieIconProps {
  showTest?: boolean;
  width?: number;
  height?: number;
}

export const AllieEllipsisHorizontalIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={ellipsisHorizontal} {...props} />
);
export const AllieEllipsisVerticalIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={ellipsisVertical} {...props} />
);
export const AllieEyeIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={eyeOutline} {...props} />
);
export const AllieChevronBackOutline: React.FC<AllieIconProps> = forwardRef((props, ref) => (
  <AllieIcon ref={ref} icon={chevronBackOutline} {...props} />
));
export const AllieChevronForward: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={chevronForwardOutline} {...props} />
);
export const AllieChevronDown: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={chevronDownOutline} {...props} />
);

export const AllieChevronUp: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={chevronUpOutline} {...props} />
);

export const AllieAddCircleIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={addCircleOutline} {...props} />
);
export const AllieBookIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={bookOutline} {...props} />
);
export const AllieBackArrowIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={arrowBackCircleOutline} {...props} />
);
export const AllieArrowBackOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={arrowBackOutline} {...props} />
);
export const AllieCloseCircleIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={closeCircle} {...props} />
);
export const AllieCloseCircleOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={closeCircleOutline} {...props} />
);
export const AllieCreateIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={createOutline} {...props} />
);
export const AllieFlagOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={flagOutline} {...props} />
);
export const AllieCloseOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={closeOutline} {...props} />
);
export const AllieLogOutOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={logOutOutline} {...props} />
);
export const AllieLogInOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={logInOutline} {...props} />
);
export const AlliePeopleOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={peopleOutline} {...props} />
);
export const AllieCheckmarkOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={checkmarkOutline} {...props} />
);
export const AllieTrashOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={trashOutline} {...props} />
);
export const AllieDocumentOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={documentOutline} {...props} />
);
export const AllieUploadOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={cloudUploadOutline} {...props} />
);
export const AllieLayersIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={LayersIcon} {...props} />
);
export const AllieCalendarCheckIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={CalendarCheckIcon} {...props} />
);
export const AllieTimeForwardIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={TimeForwardIcon} {...props} />
);
export const AllieChartIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={ChartIcon} {...props} />
);
export const AllieDownloadIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={DownloadIcon} {...props} />
);
export const AllieCopyIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={CopyIcon} {...props} />
);
export const AllieImageCopyIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={ImageCopyIcon} {...props} />
);
export const AllieThumbsUpIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={ThumbsUpIcon} {...props} />
);
export const AllieThumbsDownIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={ThumbsDownIcon} {...props} />
);
export const AllieMenuSparksOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={MenuSparksOutlineIcon} {...props} />
);
export const AllieMenuSparksIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={MenuSparksSolidIcon} {...props} />
);
export const AllieMenuBellNotificationOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={MenuBellNotificationOutlineIcon} {...props} />
);
export const AllieMenuBellNotificationIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={MenuBellNotificationSolidIcon} {...props} />
);
export const AllieMenuDashboardSpeedOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={MenuDashboardSpeedOutlineIcon} {...props} />
);
export const AllieMenuDashboardSpeedIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={MenuDashboardSpeedSolidIcon} {...props} />
);
export const AllieMenuReportsOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={MenuReportsOutlineIcon} {...props} />
);
export const AllieMenuReportsIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={MenuReportsSolidIcon} {...props} />
);
export const AllieMenuMoneySquareOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={MenuMoneySquareOutlineIcon} {...props} />
);
export const AllieMenuMoneySquareIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={MenuMoneySquareSolidIcon} {...props} />
);
export const AllieMenuSettingsOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={MenuSettingsOutlineIcon} {...props} />
);
export const AllieMenuSettingsIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={MenuSettingsSolidIcon} {...props} />
);
export const AllieSidebarCollapseIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={SidebarCollapseIcon} {...props} />
);
export const AllieSidebarExpandIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={SidebarExpandIcon} {...props} />
);
export const AllieHamburgerMenuIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={HamburgerMenuIcon} {...props} />
);
export const AllieFilterIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={FilterIcon} {...props} />
);
export const AllieSortIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={SortIcon} {...props} />
);
export const AllieMetricWarningIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={MetricWarningIcon} {...props} />
);
export const AllieAddCircleFillIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={addCircle} {...props} />
);
export const AllieAddIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={add} {...props} />
);
export const AllieAlertCircleOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={alertCircleOutline} {...props} />
);
export const AlliePulseIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={PulseIcon} {...props} />
);
export const AllieTachometerIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={TachometerIcon} {...props} />
);
export const AllieWarningOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={warningOutline} {...props} />
);
export const AllieInformationCircleOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={informationCircleOutline} {...props} />
);
export const AllieCheckmarkCicleOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={checkmarkCircleOutline} {...props} />
);
export const AllieThrashIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={trash} {...props} />
);
export const AllieCubeOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={cubeOutline} {...props} />
);
export const AllieTimeOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={timeOutline} {...props} />
);
export const AllieTimerOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={timerOutline} {...props} />
);
export const AllieLayersOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={layersOutline} {...props} />
);
export const AlliePlayCircleOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={playCircleOutline} {...props} />
);
export const AllieChatboxOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={chatboxOutline} {...props} />
);
export const AllieRepeatOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={repeatOutline} {...props} />
);
export const AllieRepeatIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={RepeatIcon} {...props} />
);
export const AllieSpeedometerIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={SpeedometerIcon} {...props} />
);
export const AllieCalendarOutline: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={calendarOutline} {...props} />
);
export const AllieEyeOpenIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={EyeOpenIcon} {...props} />
);
export const AllieEyeCloseIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={EyeCloseIcon} {...props} />
);
export const AllieCheckCircleIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={CheckCircleIcon} {...props} />
);
export const AllieClockIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={ClockIcon} {...props} />
);
export const AllieFileAddIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={FileAddIcon} {...props} />
);
export const AllieFlaskIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={FlaskIcon} {...props} />
);
export const AllieThumbsDownOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={thumbsDownOutline} {...props} />
);
export const AllieThumbsUpOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={thumbsUpOutline} {...props} />
);
export const AllieSadFaceIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={SadFaceIcon} {...props} />
);
export const AllieNeutralFaceIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={NeutralFaceIcon} {...props} />
);
export const AllieHappyFaceIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={HappyFaceIcon} {...props} />
);
export const AllieFlaskOutline: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={flaskOutline} {...props} />
);
export const AllieStopCircleOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={stopCircleOutline} {...props} />
);
export const AlliePauseCircleOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={pauseCircleOutline} {...props} />
);
export const AlliePlayOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={playOutline} {...props} />
);

export const AllieMicIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={micOutline} {...props} />
);
export const AllieBellIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={BellIcon} {...props} />
);
export const AllieCheckSquareIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={CheckSquareIcon} {...props} />
);
/** Filled square with a white checkmark — use `color` / `allieColor` to set the background fill. */
export const AllieCheckSquareSolidIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={CheckSquareSolidIcon} {...props} />
);
/** Square outline — use `color` / `allieColor` to set the stroke colour. */
export const AllieSquareOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={SquareOutlineIcon} {...props} />
);
export const AllieCaretUpOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={caretUpOutline} {...props} />
);
export const AllieCaretDownOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={caretDownOutline} {...props} />
);
export const AllieRadioOffIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={RadioOffIcon} {...props} />
);
export const AllieListIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={ListIcon} {...props} />
);
export const AllieListOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={listOutline} {...props} />
);
export const AllieStatsOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={statsChartOutline} {...props} />
);
export const AllieFilterOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={filterOutline} {...props} />
);
export const AlliePastTimeIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={PastTimeIcon} {...props} />
);
export const AllieWarningDiamondIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={WarningDiamondIcon} {...props} />
);
export const AllieBarChartIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={BarChartIcon} {...props} />
);
export const AllieFlipBackwardIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={FlipBackwardIcon} {...props} />
);
export const AllieCalendarIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={CalendarIcon} {...props} />
);
export const AllieWarningIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={WarningIcon} {...props} />
);
export const AllieDotIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={DotIcon} {...props} />
);
export const AllieTimeQuarterPastIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={TimeQuarterPastIcon} {...props} />
);
export const AllieLayersTwoIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={LayersTwoIcon} {...props} />
);
export const AlliePlayCircleIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={PlayCircleIcon} {...props} />
);
export const AllieStopCircleIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={StopCircleIcon} {...props} />
);
export const AlliePlayIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={PlayIcon} {...props} />
);
export const AllieArrowDownIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={ArrowDownIcon} {...props} />
);
export const AllieArrowUpIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={ArrowUpIcon} {...props} />
);

export const AllieLineChartUpIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={LineChartUpIcon} {...props} />
);

export const AllieLikeIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={LikeIcon} {...props} />
);

export const AllieDislikeIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={DislikeIcon} {...props} />
);

export const AllieFactoryGptIcon: React.FC<AllieIconProps & { width?: string }> = (props) => (
  <AllieCustomIcon svg={FactoryGptIcon} {...props} />
);

export const AllieStarsIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={StarsIcon} {...props} />
);

export const AllieSendIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={SendIcon} {...props} />
);

export const AlliePinUnmarked: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={PinUnmarked} {...props} />
);

export const AlliePinMarked: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={PinMarked} {...props} />
);

export const AllieSaveOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={saveOutline} {...props} />
);

export const AllieArrowForwardOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={arrowForwardOutline} {...props} />
);

export const AllieNotFoundIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={NotFoundIcon} {...props} />
);

export const AllieRefreshIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={RefreshIcon} {...props} />
);

export const AllieRefreshDoubleIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={RefreshDoubleIcon} {...props} />
);

export const AllieGridOutline: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={gridOutline} {...props} />
);

export const AllieGridBox: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={GridCompact} {...props} />
);

export const AllieDisconnectedIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={DisconnectedIcon} {...props} />
);

export const AllieChevronsUpIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={ChevronsUpIcon} {...props} />
);

export const AllieLayoutRight: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={layoutRight} {...props} />
);

export const AllieLightBulb: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={LightBulb} {...props} />
);

export const AllieSearchOutline: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={searchOutline} {...props} />
);

export const AllieChevronForwardOutline: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={chevronForwardOutline} {...props} />
);

export const AllieHardwareChipOutline: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={hardwareChipOutline} {...props} />
);

export const AlliePulseOutline: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={pulseOutline} {...props} />
);

export const AllieRefreshOutline: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={refresh} {...props} />
);

export const AllieTagOutline: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={pricetagOutline} {...props} />
);

export const AlliePlainCalendar: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={PlainCalendar} {...props} />
);

export const AllieCloudMoon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={CloudMoon} {...props} />
);

export const AllieLinkIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={Link} {...props} />
);

export const AlliePackage: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={Package} {...props} />
);

export const AllieFlag: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={Flag} {...props} />
);

export const AllieMessageQuestionCircleIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={MessageQuestionCircleIcon} {...props} />
);

export const AllieDotsGrid: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={apps} {...props} />
);

export const AllieLinkBrokenIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={LinkBrokenIcon} {...props} />
);

export const AllieWarningCirclesIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={WarningCirclesIcon} {...props} />
);

export const AlliePredictionIcon: React.FC<AllieIconProps> = (props) => (
  <PredictionIcon svg={PredictionIcon} {...props} />
);

export const AllieUnplannedStopWarningIcon: React.FC<AllieIconProps> = (props) => (
  <UnplannedStopWarningIcon svg={UnplannedStopWarningIcon} {...props} />
);

export const AlliePredictionDeactivatedIcon: React.FC<AllieIconProps> = (props) => (
  <PredictionDeactivatedIcon svg={PredictionDeactivatedIcon} {...props} />
);

export const AlliePredictionDeactivatedRoundedIcon: React.FC<AllieIconProps> = (props) => (
  <PredictionDeactivatedRoundedIcon svg={PredictionDeactivatedRoundedIcon} {...props} />
);

export const AlliePredictionLightIcon: React.FC<AllieIconProps> = (props) => (
  <PredictionIconLight svg={PredictionIconLight} {...props} />
);

export const AllieAlertCircle: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={AlertCircle} {...props} />
);

export const AllieConcentricCirclesIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={ConcentricCirclesIcon} {...props} />
);

export const AllieChatbubbleOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={chatbubbleOutline} {...props} />
);

export const AllieUploadIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={UploadIcon} {...props} />
);

export const AllieRotationClockIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={RotationClockIcon} {...props} />
);

export const AllieRotationControlIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={RotationControlIcon} {...props} />
);

export const AllieFileIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={File} {...props} />
);

export const AllieSettingIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={SettingIcon} {...props} />
);

export const AllieZoomInIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={ZoomInIcon} {...props} />
);

export const AllieNotificationsOffOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={notificationsOffOutline} {...props} />
);

export const AllieSettingsAdvancedIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={SettingsAdvancedIcon} {...props} />
);

export const AllieCoinsStackedIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={CoinsStackedIcon} {...props} />
);

export const AllieTool: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={Tool} {...props} />
);

export const AllieSlashIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={SlashIcon} {...props} />
);

export const AllieCoinsHandsIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={CoinsHands} {...props} />
);

export const AllieTrendUpIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={TrendUp} {...props} />
);

export const AllieSwapHorizontalOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={swapHorizontalOutline} {...props} />
);

export const AllieHourglassOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={hourglassOutline} {...props} />
);

export const AllieBanOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={banOutline} {...props} />
);

export const AllieFileSearchIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={FileSearchIcon} {...props} />
);

export const AllieScalesIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={ScalesIcon} {...props} />
);

export const AllieBarChartOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={BarChartOutlineIcon} {...props} />
);

export const AllieFunnelOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={funnelOutline} {...props} />
);

export const AllieZapIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={ZapIcon} {...props} />
);

export const AllieCurrencyDollarCircleIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={CurrencyDollarCircleIcon} {...props} />
);

export const AllieBellOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={BellOutlineIcon} {...props} />
);

export const AllieSendOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={sendOutline} {...props} />
);

export const AllieBackArrow = arrowBackCircleOutline;

export const AllieNamesIcons = {
  createOutline,
  trashOutline,
};

export const AllieGearSettingIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={GearSettingIcon} {...props} />
);

export const AllieChartAnalyticsIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={ChartAnalyticsIcon} {...props} />
);

export const AllieUserPersonIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={UserPersonIcon} {...props} />
);

export const AllieSlashOctagonIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={SlashOctagonIcon} {...props} />
);

export const AllieChartBreakoutSquareIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={ChartBreakoutSquareIcon} {...props} />
);

export const AllieSwitchVerticalIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={SwitchVerticalIcon} {...props} />
);

export const AllieFileLockIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={FileLockIcon} {...props} />
);

export const AllieFGPTAvatarIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={FactoryGptAvatarIcon} {...props} />
);

export const AlliePresentationChartIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={PresentationChartIcon} {...props} />
);

export const AllieFileSearchV2Icon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={FileSearchV2Icon} {...props} />
);

export const AllieEditIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={EditIcon} {...props} />
);

export const AllieRemoveCircleOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={removeCircleOutline} {...props} />
);

export const AllieAnimatedIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={AllieAnimated} {...props} />
);

export const AllieArrowUpCircleIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={arrowUpCircle} {...props} />
);

export const AllieStar06Icon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={Star06Icon} {...props} />
);

export const AllieSpeedometerOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={speedometerOutline} {...props} />
);

export const AllieTargetIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={Target} {...props} />
);

export const AllieCoinsIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={CoinsIcon} {...props} />
);

export const AllieTrendingDownOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={trendingDownOutline} {...props} />
);

export const AllieTrendingUpOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={trendingUpOutline} {...props} />
);

export const AllieSettingErrorIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={SettingError} {...props} />
);

export const AlliePauseOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={pauseOutline} {...props} />
);

export const AllieChatbubblesOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={chatbubblesOutline} {...props} />
);

export const AllieLayoutAltIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={LayoutAlt} {...props} />
);

export const AllieHomeOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={homeOutline} {...props} />
);

export const AllieHomeIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={HomeIcon} {...props} />
);

export const AllieChevronUpDoubleIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={ChevronUpDouble} {...props} />
);

export const AllieCogOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={cogOutline} {...props} />
);

export const AllieCopyOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={copyOutline} {...props} />
);

export const AllieUnpluggedIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={UnpluggedIcon} {...props} />
);
export const AllieMonitorIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={MonitorIcon} {...props} />
);

export const AllieMoreVertIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={MoreVertIcon} {...props} />
);

export const AllieMoreHorizCircleIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={MoreHorizCircleIcon} {...props} />
);

export const AllieProhibitionIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={ProhibitionIcon} {...props} />
);

export const AllieLogoIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={AllieLogo} {...props} />
);

export const AllieMenuLogoIcon: React.FC<AllieMenuLogoIconProps> = (props) => (
  <AllieCustomIcon svg={AllieMenuLogo} {...props} />
);

export const AllieScanOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={scanOutline} {...props} />
);

export const AllieEditPencilIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={EditPencil} {...props} />
);

export const AllieEfficiencyMenuMobileApp: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={EfficiencyMenuMobileApp} {...props} />
);

export const AllieFactoryGptMenuMobileApp: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={FactoryGptMenuMobileApp} {...props} />
);

export const AllieAlertMenuMobileApp: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={AlertMenuMobileApp} {...props} />
);

export const AllieEfficiencyMenuSelectedMobileApp: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={EfficiencyMenuSelectedMobileApp} {...props} />
);

export const AllieFactoryGptMenuSelectedMobileApp: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={FactoryGptMenuSelectedMobileApp} {...props} />
);

export const AllieAlertMenuSelectedMobileApp: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={AlertMenuSelectedMobileApp} {...props} />
);

export const AlliePlainCheckIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={PlainCheck} {...props} />
);

export const AllieBanHexa: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={BanHexa} {...props} />
);

export const AllieMenuBellMobileApp: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={MenuBellMobileApp} {...props} />
);

export const AllieMenuBellSelectedMobileApp: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={MenuBellSelectedMobileApp} {...props} />
);

export const AllieUserIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={UserIcon} {...props} />
);

export const AllieArrowLeftIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={ArrowLeftIcon} {...props} />
);

export const AllieArrowRightIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={ArrowRightIcon} {...props} />
);

export const AllieWifiOffGenericIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={WifiOffGenericIcon} {...props} />
);

export const AllieWifiOffPageIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={WifiOffPageIcon} {...props} />
);

export const AllieLinkOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={linkOutline} {...props} />
);

export const AllieHelpCircleOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={helpCircleOutline} {...props} />
);

export const AllieSparklesOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={SparklesOutlineIcon} {...props} />
);

export const AllieHammerOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={HammerOutlineIcon} {...props} />
);

export const AllieCheckmarkDoneOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={CheckmarkDoneOutlineIcon} {...props} />
);

export const AllieCloudOfflineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={CloudOfflineIcon} {...props} />
);

export const AllieRemoveOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={removeOutline} {...props} />
);

export const AllieJournalPageIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={JournalPageIcon} {...props} />
);

export const AllieClockStrokeIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={ClockStrokeIcon} {...props} />
);

export const AllieGraphUpIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={GraphUpIcon} {...props} />
);

export const AllieGearSettingStrokeIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={GearSettingStrokeIcon} {...props} />
);

export const AllieLinkSlashIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={LinkSlashIcon} {...props} />
);

export const AllieCloudXmarkIcon: React.FC<AllieIconProps> = (props) => (
  <AllieCustomIcon svg={CloudXmarkIcon} {...props} />
);

export const AllieAlertOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={alertOutline} {...props} />
);

export const AllieConstructOutlineIcon: React.FC<AllieIconProps> = (props) => (
  <AllieIcon icon={constructOutline} {...props} />
);
